import {useState} from "react";
import {RsExternalAddress} from "../../api/dto/RsExternalAddress";
import {AddressService} from "../../service/AddressService";

export const GetExternalAddressViewModel =  () => {

    const [address, setAddress] = useState<RsExternalAddress>()
    const [loading, setLoading] = useState(false)

    const getExternalAddress = async (id: number, verificationId: string) => {
        setLoading(true)
        const result = await AddressService.getInstance().getExternalAddressById(id, verificationId)
        setAddress(result)
        setLoading(false)
        return result
    }

    return {
        address,
        loading,
        getExternalAddress,
    }

}